import { AppRegistry } from 'react-native';
import name from '../app.json';
import App from '../App';

// This is done for Ionicons, just follow the pattern to add others like materialicons, etc
import Ionicons from '@react-native-vector-icons/ionicons/fonts/Ionicons.ttf';
import FontAwesome from './Fonts/FontAwesome.ttf';
import MaterialIcons from './Fonts/MaterialIcons.ttf';
import MaterialCommunityIcons from './Fonts/MaterialCommunityIcons.ttf';
import MaterialDesignIcons from '@react-native-vector-icons/material-design-icons/fonts/MaterialDesignIcons.ttf';
import FontAwesome5_Brands from './Fonts/FontAwesome5_Brands.ttf'
import FontAwesome5_Regular from './Fonts/FontAwesome5_Regular.ttf'
import FontAwesome5_Solid from './Fonts/FontAwesome5_Solid.ttf'


const IoniconsStyles = `@font-face {
  src: url(${Ionicons});
  font-family: Ionicons;
}`;

const FontAwesomeStyles = `@font-face {
  src: url(${FontAwesome});
  font-family: FontAwesome;
}`;

const MaterialIconsStyles = `@font-face {
  src: url(${MaterialIcons});
  font-family: MaterialIcons;
}`;

const MaterialCommunityIconsStyles = `@font-face {
  src: url(${MaterialCommunityIcons});
  font-family: MaterialCommunityIcons;
}`;

const MaterialDesignIconsStyles = `@font-face {
  src: url(${MaterialDesignIcons});
  font-family: MaterialDesignIcons;
}`;

const FontAwesome5_BrandsStyles = `@font-face {
  src: url(${FontAwesome5_Brands});
  font-family: FontAwesome5_Brands;
}`;


const FontAwesome5_RegularStyles = `@font-face {
  src: url(${FontAwesome5_Regular});
  font-family: FontAwesome5_Regular;
}`;


const FontAwesome5_SolidStyles = `@font-face {
  src: url(${FontAwesome5_Solid});
  font-family: FontAwesome5_Solid;
}`;


const style = document.createElement('style');
style.type = 'text/css';

if (style.styleSheet) {
  style.styleSheet.cssText = MaterialCommunityIcons;
} else {
  style.appendChild(document.createTextNode(IoniconsStyles));
  style.appendChild(document.createTextNode(FontAwesomeStyles));
  style.appendChild(document.createTextNode(FontAwesome5_BrandsStyles));
  style.appendChild(document.createTextNode(FontAwesome5_RegularStyles));
  style.appendChild(document.createTextNode(FontAwesome5_SolidStyles));
  style.appendChild(document.createTextNode(MaterialIconsStyles));
  style.appendChild(document.createTextNode(MaterialCommunityIconsStyles));
  style.appendChild(document.createTextNode(MaterialDesignIconsStyles));

}

document.head.appendChild(style);

if (module.hot) {
  module.hot.accept();
}


AppRegistry.registerComponent(name, () => App);
AppRegistry.runApplication(name, {
  initialProps: {},
  rootTag: document.getElementById('app-root')
});